import React from "react";
import { Link } from "react-router-dom";
import pawImg from '../assets/paw.png';
import './supplements.css';

const HomemadeDogFoodForAllergies: React.FC = () => (
  <div className="page-container cream-bg">
    {/* Floating Paw Print Background */}
    <div className="hero-paw-bg">
      <img src={pawImg} className="hero-paw-float paw1" alt="" />
      <img src={pawImg} className="hero-paw-float paw2" alt="" />
      <img src={pawImg} className="hero-paw-float paw3" alt="" />
      <img src={pawImg} className="hero-paw-float paw4" alt="" />
      <img src={pawImg} className="hero-paw-float paw5" alt="" />
      <img src={pawImg} className="hero-paw-float paw6" alt="" />
      <img src={pawImg} className="hero-paw-float paw7" alt="" />
    </div>
    <div className="page-intro">
      <h1 className="page-title">Homemade Dog Food for Dogs With Allergies</h1>
      <div className="page-intro-underline" />
      <p className="page-intro-desc">
        Food allergies and sensitivities can make finding the right diet challenging. Many commercial foods contain common allergens such as chicken, beef, dairy, or fish, which can trigger itching, digestive upset, ear infections, and other symptoms in sensitive dogs.
      </p>
    </div>
    <div className="supplements-content">
      <h2>Common Signs of Food Sensitivities</h2>
      <ul>
        <li>Itchy skin</li>
        <li>Excessive licking or scratching</li>
        <li>Recurring ear infections</li>
        <li>Digestive upset</li>
        <li>Chronic loose stools</li>
      </ul>

      <h2>Choosing the Right Protein</h2>
      <p>
        Many dogs benefit from trying a novel protein, which is a protein source they have not eaten regularly before. Examples include:
      </p>
      <ul>
        <li>Venison</li>
        <li>Horse</li>
        <li>Turkey</li>
        <li>Salmon</li>
      </ul>

      <h2>Allergy-Friendly Recipes</h2>
      <ul>
        <li><Link to="/recipes/venison-sweet-potato">Venison & Sweet Potato Allergy Bowl</Link></li>
        <li><Link to="/recipes/horse-pumpkin">Horse & Pumpkin Comfort Bowl</Link></li>
        <li><Link to="/recipes/turkey-oat">Turkey & Oat Gentle Bowl</Link></li>
        <li><Link to="/recipes/salmon-pumpkin">Salmon & Pumpkin Sensitive Bowl</Link></li>
      </ul>

      <h2>Calculate Portions</h2>
      <p>
        Every dog is different. Use our <Link to="/recipe-builder">portion calculator</Link> to estimate daily feeding amounts based on your dog's weight, age, and activity level.
      </p>

      <h2>Whole Food and Supplement Balancing</h2>
      <p>
        Recipes can be balanced using either:
      </p>
      <ul>
        <li>Whole food nutrient sources</li>
        <li>A complete canine vitamin–mineral supplement</li>
      </ul>
      <p>
        Choose one balancing method and follow the <Link to="/supplements">recipe instructions</Link> carefully.
      </p>

      <h2>Explore More Recipes</h2>
      <p>
        Browse our growing collection of <Link to="/recipes">homemade dog food recipes</Link>, feeding guides, and educational resources.
      </p>
    </div>
  </div>
);

export default HomemadeDogFoodForAllergies;
